import React, { useEffect } from "react";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import "./App.css";
import EnglishTranslation from "./locales/en/index";
import FrenchTranslation from "./locales/fr/index";
import Header from "./components/global/Header/Header.jsx";
import Footer from "./components/global/Footer/Footer.jsx";
import Router from "./components/global/Router";
import { useDispatch, useSelector } from "react-redux";
import { updateLastActivity } from "./features/auth/idleSlice";
import { authLoginSelector, logoutUser } from "./features/auth/authLoginSlice";
//import IdleTimeoutChecker from "./components/global/IdleTimeoutChecker/IdleTimeoutChecker";
import moment from "moment";
import { getSession, setSession } from "./common/utils";
import IdleTimerContainer from "./components/global/IdleTimerContainer/IdleTimerContainer.js";

// Multiple languages are loaded on app startup whih ensures that all the translations are according to the current language.
i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: EnglishTranslation,
    },
    fr: {
      translation: FrenchTranslation,
    },
  },
  lng: "en",
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
});

// Our entire app is wrapped around in header and
// footer component which ensures that we will have
// a header and a footer on every page without including that on every route.

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector(authLoginSelector);

  // useEffect(() => {
  //   const handleUserActivity = () => {
  //     // console.log('Session time: ', moment(getSession()).format('hh:mm A'));
  //     // console.log('Current time: ', moment().format('hh:mm A'));
  //     // console.log(
  //     //   'Difference: ',
  //     //   moment().diff(moment(getSession()), 'minutes')
  //     // );
  //     if (moment().diff(moment(getSession()), 'minutes') > 240) {
  //       dispatch(logoutUser());
  //     } else {
  //       if (isAuthenticated) {
  //         setSession();
  //       }
  //     }
  //     // dispatch(updateLastActivity());
  //     // window.localStorage.setItem('session', new Date());
  //     // Additional logic for handling user activity
  //   };
  //   handleUserActivity();
  //   if (isAuthenticated) {
  //     document.addEventListener('mousemove', handleUserActivity);
  //     document.addEventListener('keydown', handleUserActivity);
  //     document.addEventListener('mousedown', handleUserActivity);
  //     document.addEventListener('touchstart', handleUserActivity);
  //     document.addEventListener('click', handleUserActivity);
  //   }

  //   return () => {
  //     // Clean up event listeners
  //     if (isAuthenticated) {
  //       document.removeEventListener('mousemove', handleUserActivity);
  //       document.removeEventListener('keydown', handleUserActivity);
  //       document.removeEventListener('mousedown', handleUserActivity);
  //       document.removeEventListener('touchstart', handleUserActivity);
  //       document.removeEventListener('click', handleUserActivity);
  //     }
  //   };
  // }, []);

  return (
    <div id="root">
      {isAuthenticated && <IdleTimerContainer />}
      <main>
        <Header />
        <Router />
      </main>
      <Footer />
    </div>
  );
}

export default App;
